import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import ForWho from './components/ForWho';
import Unique from './components/Unique';
import Areas from './components/Areas';
import Methodology from './components/Methodology';
import HowItWorks from './components/HowItWorks';
import SelectiveProcess from './components/SelectiveProcess';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <Navbar />
      <div className="max-w-screen-2xl mx-auto">
        <Hero />
        <About />
        <ForWho />
        <Unique />
        <Areas />
        <Methodology />
        <HowItWorks />
        <SelectiveProcess />
        <FAQ />
        <Contact />
      </div>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}